<template>
  <div>
    <h1
      v-bind:style="{ color: Company.CI_Headlinecolor }"
      class="mb-4"
    >{{LanguageStrings[DisplayLanguage]['nav_settings']}}</h1>
    <div v-if="showNewMailOK" class="alert alert-success mb-4" role="alert">
      {{LanguageStrings[DisplayLanguage]['login_activateemail']}}
    </div>
    <h2 v-if="Company.RegisterMode != 0" v-bind:style="{ color: Company.CI_Headlinecolor }">{{LanguageStrings[DisplayLanguage]['settings_changemail_head']}}:</h2>
    <form v-if="Company.RegisterMode != 0" id="changemailform" onsubmit="return false;" class="mt-4">
      <div class="form-group">
        <label
          for="form_newmail"
          v-bind:style="{ color: Company.CI_Textcolor }"
        >{{LanguageStrings[DisplayLanguage]['settings_newmail']}}</label>
        <input
          type="text"
          class="form-control"
          name="form_newmail"
          v-model="newMail"
        />
      </div>
      <div class="form-group">
        <label
          for="form_newmail2"
          v-bind:style="{ color: Company.CI_Textcolor }"
        >{{LanguageStrings[DisplayLanguage]['settings_newmail2']}}</label>
        <input
          type="text"
          class="form-control"
          name="form_newmail2"
          v-model="newMail2"
        />
      </div>
      <div>
        <input
          class="btn btn-primary"
          type="button"
          :value="LanguageStrings[DisplayLanguage]['settings_change']"
          :disabled="new RegExp(/^[a-zA-Z0-9\.\-_]+@[a-zA-Z0-9\.\-_]+\.[a-zA-Z0-9\.]{2,}$/).exec(newMail + '') == null || newMail != newMail2"
          @click="changeMail()"
        />
      </div>
    </form>
    <hr v-if="Company.RegisterMode != 0" v-bind:style="{ borderTop: '1px solid ' + Company.CI_Hrcolor }" />
    <h2 v-bind:style="{ color: Company.CI_Headlinecolor }">{{LanguageStrings[DisplayLanguage]['settings_change_password']}}:</h2>
    <form id="changepwform" onsubmit="return false;" class="mt-4">
      <div class="form-group">
        <label
          for="form_password"
          v-bind:style="{ color: Company.CI_Textcolor }"
        >{{LanguageStrings[DisplayLanguage]['settings_new_password']}}</label>
        <input
          type="password"
          autocomplete="password"
          class="form-control"
          name="form_password"
          v-model="password"
        />
      </div>
      <div class="form-group">
        <label
          for="form_password2"
          v-bind:style="{ color: Company.CI_Textcolor }"
        >{{LanguageStrings[DisplayLanguage]['settings_new_password2']}}</label>
        <input
          type="password"
          autocomplete="password"
          class="form-control"
          name="form_password2"
          v-model="password2"
          v-on:keyup.enter="changePassword()"
        />
      </div>
      <div>
        <input
          class="btn btn-primary"
          type="button"
          :value="LanguageStrings[DisplayLanguage]['settings_change']"
          :disabled="(password+'').length < 8 || password != password2 || new RegExp('[A-Z]').exec(password+'') == null || new RegExp('[a-z]').exec(password+'') == null || new RegExp('[0-9]').exec(password+'') == null"
          @click="changePassword()"
        />
        <span v-if="passwordOK" class="text-success" style="margin-left:10px;font-size:20px;font-weight:bold"><i class="far fa-check-circle"></i></span>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SettingsEsprit",
  components: {
    //HelloWorld
  },
  data: function() {
    return {
      password: null,
      password2: null,
      newMail: null,
      newMail2: null,
      showNewMailOK: false,
      passwordOK: false,
    };
  },
  mounted: function() {},
  computed: {},
  methods: {
    changeReveive: function(mode) {
      this.$parent.$parent.errortext = null;
      var self = this;
      self.showNewMailOK = false;
      axios
        .post(
          this.GS.Endpoint + "/v2/changereceive/" + this.Session.SessionId + "/" + (mode ? "true" : "false"),
          {},
          {}
        )
        .then(function(response) {
          self.GS.Session.ReceiveSecMail = mode;
        })
        .catch(function(response) {
          if (response.response == undefined) {
            self.$parent.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.$parent.errortext = "sessionexpired";
            return;
          }
          self.$parent.$parent.errortext = "internalservererror";
        });
    },
    changeMail: function() {
      this.$parent.$parent.errortext = null;
      var self = this;
      self.showNewMailOK = false;
      self.passwordOK = false;
      axios
        .post(
          this.GS.Endpoint + "/v2/changemail/" + this.Session.SessionId,
          this.form2JSON(document.getElementById("changemailform")),
          {}
        )
        .then(function(response) {
          self.newMail = null;
          self.newMail2 = null;
          self.showNewMailOK = true;
        })
        .catch(function(response) {
          self.newMail = null;
          self.newMail2 = null;
          self.showNewMailOK = false;
          if (response.response == undefined) {
            self.$parent.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.$parent.errortext = "sessionexpired";
            return;
          }
          if (response.response.status == 412) {
            self.$parent.$parent.errortext = "register_already_exists";
            return;
          }
          self.$parent.$parent.errortext = "internalservererror";
        });
    },
    changePassword: function() {
      if((this.password+'').length < 8 || this.password != this.password2 || new RegExp('[A-Z]').exec(this.password+'') == null || new RegExp('[a-z]').exec(this.password+'') == null || new RegExp('[0-9]').exec(this.password+'') == null)
      {
        return;
      }
      this.$parent.$parent.errortext = null;
      var self = this;
      self.showNewMailOK = false;
      self.passwordOK = false;
      axios
        .post(
          this.GS.Endpoint + "/v2/changepassword/" + this.Session.SessionId,
          this.form2JSON(document.getElementById("changepwform")),
          {}
        )
        .then(function(response) {
          self.password = null;
          self.password2 = null;
          self.passwordOK = true;
        })
        .catch(function(response) {
          self.password = null;
          self.password2 = null;
          if (response.response == undefined) {
            self.$parent.$parent.errortext = "internalservererror";
            return;
          }
          if (response.response.status == 410) {
            self.$parent.$parent.errortext = "sessionexpired";
            return;
          }

          self.$parent.$parent.errortext = "internalservererror";
        });
    },
  }
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
h2 {
  font-size: 16px;
}
input {
  font-size: 13px;
}
hr {
  display: block;
  height: 1px;
  border: 0;
  margin: 1em 0;
  padding: 0;
}
</style>
